<div class="pd-logo">
  <p-text [size]="'medium'" [weight]="'bold'">Porsche</p-text>
  <!-- eslint-disable-next-line @angular-eslint/template/prefer-self-closing-tags -->
  <p-text [size]="'medium'">&nbsp;</p-text>
  <p-text [color]="'inherit'" [size]="'medium'" [weight]="'bold'">Digital</p-text>
</div>
<p-text [size]="'x-small'">Croatia</p-text>
